module.exports = __webpack_public_path__ + "img/Award.2f09fe65.jpg";